/* eslint-disable react/button-has-type,react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { autobind } from 'core-decorators';
import classNames from 'classnames';

import styles from './index.styl';

/*
 * TODO: aria-attrs
 * */

@CSSModules(styles, { allowMultiple: true })
export default class Button extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    raised: PropTypes.bool,
    icon: PropTypes.bool,
    border: PropTypes.bool,
    ariaLabel: PropTypes.string,
  };

  button = null;

  @autobind
  removeFocus() {
    this.button.blur();
  }

  render() {
    const {
      children,
      className,
      color,
      disabled,
      raised,
      border,
      icon,
      ariaLabel,
      ...other
    } = this.props;

    return (
      <button
        {...{ children, className, disabled, ...other }}
        styleName={classNames(
          'root',
          { [`root--color--${color}`]: color },
          { 'root--disabled': disabled },
          { 'root--raised': raised },
          { 'root--icon': icon },
          { 'root--border': border },
        )}
        ref={node => (this.button = node)}
        onMouseUp={() => this.removeFocus()}
        aria-label={ariaLabel || 'button'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.jsx